import { createRouter, createWebHistory } from "vue-router";
import HomeView from "../views/HomeView.vue";
import { useAuthStore } from "@/stores/auth";

const routes = [
  {
    path: "/",
    name: "home",
    component: HomeView,
  },
  {
    path: "/about",
    name: "about",
    component: () => import("../views/AboutView.vue"),
  },
  {
    path: "/login",
    name: "login",
    component: () => import("../views/LoginView.vue"),
    meta: { requiresGuest: true },
  },
  {
    path: "/signup",
    name: "signup",
    component: () => import("../views/SignupView.vue"),
    meta: { requiresGuest: true },
  },
  {
    path: "/dashboard",
    name: "dashboard",
    component: () => import("../views/DashboardView.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/create",
    name: "createMemory",
    component: () => import("../views/CreateMemoryView.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/create-did",
    name: "createMemoryDid",
    component: () => import("../views/CreateMemoryDidView.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/r/:token",
    name: "recordMemory",
    component: () => import("../views/RecordView.vue"),
  },
  {
    path: "/welcome/:token",
    name: "onboarding",
    component: () => import("../views/OnboardingView.vue"),
  },
  // UPDATED: Public view for a single memory, now with userId
  {
    path: "/memory/:userId/:memoryId",
    name: "memoryView",
    component: () => import("../views/MemoryView.vue"),
  },
  {
    path: "/did-playground",
    name: "didPlayground",
    component: () => import("../views/DidPlayground.vue"),
    meta: { requiresAuth: true },
  },
  // ADDED: Catch-all 'Not Found' route (must be last)
  {
    path: "/:pathMatch(.*)*",
    name: "NotFound",
    component: () => import("../views/NotFoundView.vue"),
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach(async (to, from, next) => {
  const authStore = useAuthStore();

  // Wait for the initial auth state check to complete
  await authStore.listenToAuthState();

  const isAuthenticated = authStore.isAuthenticated;

  // Now that we're sure about the auth state, apply routing rules
  if (to.meta.requiresAuth && !isAuthenticated) {
    next({ name: "login", query: { redirect: to.fullPath } });
  } else if (to.meta.requiresGuest && isAuthenticated) {
    next({ name: "dashboard" });
  } else {
    next();
  }
});

export default router;
